import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from '@/types/order';
import { Modal } from '@/types/modal';
import Grid, { GridAction, itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';
import ModalView from '@/components/modals/Modal';

const View: React.FC<{ order: Order }> = ({ order }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState<Modal | null>(null);

  const actions: GridAction[] = [
    {
      kind: 'Button',
      label: t('common.update').toUpperCase(),
      onClick: () => setModal({ kind: 'UpdateOrderDeliveryHome', order, onClose: () => setModal(null) }),
      disabled: order.isUpdateDeliveryAddressEnabled === false,
    },
  ];

  const items = [
    itemText(t('order.delivery_home.first_name'), order.firstName),
    itemText(t('order.delivery_home.surname'), order.lastName),
    itemText(t('order.delivery_home.company'), order.orderCompany),
    itemText(t('order.delivery_home.telephone'), order.orderTelephone !== '' ? '+' + order.orderTelephone : '-'),
    itemText(t('order.delivery_home.address1'), order.orderAddress1),
    itemText(t('order.delivery_home.address2'), order.orderAddress2),
    itemText(t('order.delivery_home.district'), order.orderDistrict),
    itemText(t('order.delivery_home.city'), order.orderCity),
    itemText(t('order.delivery_home.province'), order.orderProvince),
    itemText(t('order.delivery_home.zip'), order.orderZipCode),
    itemText(t('order.delivery_home.country'), order.orderCountry),
  ];

  return (
    <>
      <Container
        title={t('order.delivery_home.title')}
        actions={actions}
        testId="delivery_home"
      >
        <Grid
          column={5}
          items={items}
        />
      </Container>
      <ModalView modal={modal} />
    </>
  );
};

export default View;
